import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

/* ── Chunk-load error recovery ────────────────────────────────────
   After a Vercel redeploy, old JS chunk URLs (content-hash filenames)
   no longer exist on the CDN. If the browser has cached the old
   index.html and tries to load a now-deleted chunk, React silently
   fails to mount and data never appears. We detect this and force a
   single hard reload to pick up the fresh index.html + new chunks.
   A sessionStorage flag prevents infinite reload loops.
──────────────────────────────────────────────────────────────────── */
function isChunkError(msg) {
  return (
    typeof msg === 'string' &&
    (msg.includes('Loading chunk') ||
     msg.includes('ChunkLoadError') ||
     msg.includes('Failed to fetch dynamically') ||
     msg.includes('Importing a module script failed'))
  );
}

window.addEventListener('error', (e) => {
  if (isChunkError(e?.message)) {
    if (!sessionStorage.getItem('chunk_reload')) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload(true);
    }
  }
});

window.addEventListener('unhandledrejection', (e) => {
  if (isChunkError(e?.reason?.message) || isChunkError(e?.reason?.name)) {
    if (!sessionStorage.getItem('chunk_reload')) {
      sessionStorage.setItem('chunk_reload', '1');
      window.location.reload(true);
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
